import { createContext, ReactNode, useContext, useState } from 'react';

type ContextProps = {
	hideAction: boolean;
	setHideAction: (data: boolean) => void;
};

type ContextProviderProps = {
	children: ReactNode;
};

export const HoSoBenhAnContext = createContext<ContextProps>({
	hideAction: false,
	setHideAction: () => {},
});

export const HoSoBenhAnContextProvider = ({ children }: ContextProviderProps) => {
	const [hideAction, setHideAction] = useState<boolean>(false);

	return (
		<HoSoBenhAnContext.Provider
			value={{
				hideAction,
				setHideAction,
			}}
		>
			{children}
		</HoSoBenhAnContext.Provider>
	);
};

export const useHoSoBenhAnContext = () => {
	const context = useContext(HoSoBenhAnContext);

	if (!context) {
		throw new Error('useHoSoBenhAnContext must be used within a HoSoBenhAnContextProvider');
	}

	return context;
};
